import cn from 'classnames'
import { FC } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { ConfirmationDialogContent } from './confirmationDialogContent/ConfirmationDialogContent'
import { TConfirmationDialogProps } from './TConfirmationDialogProps'

import styles from './ConfirmationDialog.module.scss'

export const ConfirmationDialog: FC<TConfirmationDialogProps> = ({
  isVisible,
  size = 'sm',
  windowClassName,
  ...props
}) => {
  return (
    <ModalDialog
      classes={{ window: cn(styles.window, windowClassName) }}
      content={ConfirmationDialogContent}
      onClose={() => undefined}
      contentProps={props}
      show={isVisible}
      size={size}
      closeOnOutsideClick={false}
    />
  )
}
